import { gql, MutationHookOptions, useMutation } from '@apollo/client';

export const UPDATE_QUIZ_RESPONSE_MUTATION = gql`
mutation updateQuizResponse($id: ID!, $input: UpdateQuizResponseInput!) {
  updateQuizResponse(id: $id, input: $input) {
    id
    isReportApproved
    aiReportData
  }
}

`;

export type AiReportData = {
    mainProfile: string;
    foreignTraits: { name: string; description: string }[];
    dominantTraits: { name: string; description: string }[];
};

export type UpdateQuizResponseVariables = {
    id: string;
    input: {
        isReportApproved: boolean;
        aiReportData: AiReportData | null;
    };
};

export type UpdateQuizResponseResponse = {
    updateQuizResponse: {
        id: string;
        isReportApproved: boolean;
        aiReportData: AiReportData | null;
    };
};

export const useUpdateQuizResponseMutation = (
    options: MutationHookOptions<UpdateQuizResponseResponse, UpdateQuizResponseVariables> = {},
) =>
    useMutation<UpdateQuizResponseResponse, UpdateQuizResponseVariables>(
        UPDATE_QUIZ_RESPONSE_MUTATION,
        options,
    );
